<template>
  <div>
    <NavBarSectionItem
      :label="label"
      :icon="icon"
      :is-selected="isSelected"
      :is-section="isSection"
      :to-name="toName"
      @click="$emit('select')"
    />
    <div v-if="isSelected && items.length > 0">
      <NavBarItem
        v-for="item in items"
        :key="item.label"
        :label="item.label"
        :icon="item.icon"
        :to="item.to"
        :to-name="item.toName"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
interface NavItem {
  label: string
  icon: string
  to?: string
  toName?: string
  isSection: boolean
}

defineProps({
  label: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    required: true,
  },
  toName: {
    type: String,
    required: false,
    default: undefined,
  },
  isSelected: {
    type: Boolean,
    default: false,
  },
  items: {
    type: Array as PropType<NavItem[]>,
    default: () => [],
  },
  isSection: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['select'])
</script>
